import Vue from 'vue'
import moment from 'vue-moment'
import router from './router'
import cognito from './cognito'
import App from './App.vue'
import store from './store'
import Axios from 'axios'

Vue.config.productionTip = false
Vue.use(moment)
if(process.env.VUE_APP_API_ENDPOINT) {
  Axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
}

new Vue({
  store,
  cognito,
  router,
  render: h => h(App)
}).$mount('#app')
